import React, { useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import api from '../../functions/api';
import { useToast } from '../ToastProvider';
import { ReactComponent as IconClose } from "../../assets/icons/icon-close.svg";

const DeleteThreadConfirm = ({ data, show, handleClose, onDeleted }) => {
  const { showSuccess, showError } = useToast();
  const [loading, setLoading] = useState(false);

  if (!data) return null;

  const handleDelete = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('access_token');
      const idUser = localStorage.getItem('id_user');
      await api.delete(`/langgraph/threads/${idUser}`, {
        headers: { Authorization: `Bearer ${token}` },
        data: { uuid: data.uuid },
      });
      showSuccess('Conversación eliminada');
      onDeleted?.(data.uuid);
      handleClose();
    } catch (err) {
      console.error(err);
      showError('No se pudo eliminar la conversación');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered dialogClassName="basic-modal">
      <Modal.Header closeButton={false}>
        <Modal.Title>Eliminar Conversación</Modal.Title>
        <button
          type="button"
          onClick={handleClose}
          aria-label="Cerrar modal"
          className="btn-reset ms-auto modal-close-icon"
        >
          <IconClose className="mc-link__icon secondary" />
        </button>
      </Modal.Header>

      <Modal.Body className="text-center">
        <p className="confirm-text">
          ¿Seguro que deseas eliminar?
        </p>
      </Modal.Body>

      <Modal.Footer className="delete-confirm-btns">
        <Button
          onClick={handleDelete}
          disabled={loading}
          className="btn-pill btn-affirm"
        >
          {loading ? <Spinner size="sm" /> : 'Si'}
        </Button>

        <Button
          onClick={handleClose}
          className="btn-pill btn-cancel"
          variant="light"
        >
          No
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteThreadConfirm;
